<template>
    <div>
        <v-card color="white" width="100%">
            <v-toolbar color="amber" height="40">
                <v-btn icon @click="close()"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-black ">Daily Updates</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-chip label color="black" text-color="amber" v-if="natureType != ''" class="caption font-weight-bold text-uppercase mr-5"> {{natureType}}
                </v-chip>
            </v-toolbar>
            <v-form class="pa-5">
            <v-row>
                <v-col cols=12 md=12 lg=12 sm=12>
                    <v-select :items="productRecords" v-model="product" color="amber" 
                    outlined label="Select Products" item-text="name" item-value="id"></v-select>
                </v-col>
            </v-row>
            <!--------------------------- Purchase Form A Start------------------------------>
            <v-row v-if="pF == 'PurchaseFormA'">
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="conditionRate" color="amber" label="42% Oil Content Condition Rate" outlined></v-text-field>
                </v-col>
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="nonConditionRate" color="amber" label="Non-Condition Ex Rate" outlined></v-text-field>
                </v-col>
            </v-row>
            <!--------------------------- Purchase Form A End------------------------------>
            <!--------------------------- Purchase Form B Start------------------------------>
            <v-row v-if="pF == 'PurchaseFormB'">
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="conditionRate" color="amber" label="Solvent Condition Rate" outlined></v-text-field>
                </v-col>
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="nonConditionRate" color="amber" label="Non-Condition Rate" outlined></v-text-field>
                </v-col>
            </v-row>
            <!--------------------------- Purchase Form B Start------------------------------>
            <!--------------------------- Purchase Form C Start------------------------------>
            <v-row v-if="pF == 'PurchaseFormC'">
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="looseRatePbHr" color="amber" label="Loose Rate PB/HR Rate" outlined></v-text-field>
                </v-col>
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="looseRateSumerpur" color="amber" label="Loose Rate Sumerpur" outlined></v-text-field>
                </v-col>
            </v-row>
            <!--------------------------- Purchase Form C End------------------------------>
            <!--------------------------- Sale Form A Start------------------------------>
            <v-row v-if="pF == 'SaleFormA'">
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="readyRate" color="amber" label="Ready Rate" outlined></v-text-field>
                </v-col>
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="forwardRate" color="amber" label="Forward Rate" outlined></v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="pF == 'SaleFormA'">
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-menu ref="menu" v-model="readyLiftMenu" :close-on-content-click="true" transition="scale-transition" 
                    offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="readyLiftingIn" label="Ready Lifting Date"  outlined prepend-inner-icon="mdi-calendar-range" color="amber"
                            readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker color="amber" v-model="readyLiftingIn" scrollable></v-date-picker>
                    </v-menu>
                </v-col>
                <!--------------------------------------------------->
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-menu ref="menu" v-model="forwardLiftMenu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="forwardLiftingIn" label="Forward Lifting Date"  outlined prepend-inner-icon="mdi-calendar-range" color="amber"
                             readonly v-on="on"></v-text-field>
                        </template>
                         <v-date-picker color="amber" v-model="forwardLiftingIn" scrollable></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <!--------------------------- Sale Form A End------------------------------>
             <!--------------------------- Sale Form B Start------------------------------>
            <v-row v-if="pF == 'SaleFormB'">
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="readyRate" color="amber" label="EX Ready Rate" outlined></v-text-field>
                </v-col>
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="forwardRate" color="amber" label="EX Forward Rate" outlined></v-text-field>
                </v-col>
            </v-row>
            <!-- -------------------------------------------------------------------->
            <v-row v-if="pF == 'SaleFormB'">
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="readyLiftingIn" color="amber" label="Ready Lifting Days" outlined></v-text-field>
                </v-col>
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="forwardLiftingIn" color="amber" label="Forward Lifting Days" outlined></v-text-field>
                </v-col>
            </v-row>
            <!-- -------------------------------------------------------------------->
            <v-row v-if="pF == 'SaleFormB'">
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="forReadyCday" color="amber" label="FOR Ready Credit Days" outlined></v-text-field>
                </v-col>
                <v-col cols=12 md=6 lg=6 sm=6>
                    <v-text-field v-model="forForwardCday" color="amber" label="FOR Forward Credit Days" outlined></v-text-field>
                </v-col>
            </v-row>
            <!--------------------------- Sale Form B End------------------------------>
            </v-form>
            <v-col cols=12 md=12 lg=12 sm=12 class="text-right">
                <v-btn  color="amber" class="black--text" :loading="loading" @click="Save()">Save</v-btn>
            </v-col> 
            
        </v-card>
        <span style="dispaly:none;">{{checkfetch}}</span>
    </div>
</template>

<script>
import { SERVER_API } from '../../API';
export default {
    props:['productId'],
    created(){
        window.addEventListener('keyup', event => {
            if(event.which === 27){
                this.close();
            }
        })
    },
    mounted(){
        this.fetchAll();
    },
    data(){
        return{
            loading:false,
            conditionRate:'',
            nonConditionRate:'',
            looseRatePbHr:'',
            looseRateSumerpur:'',
            readyRate:'',
            forwardRate:'',
            forReadyCday:'',
            forForwardCday:'',
            readyLiftingIn:'',
            forwardLiftingIn:'',
            forwardLiftMenu:false,
            readyLiftMenu:false,
            natureType:'',
            product:'',
            pF:'',

            //Store Data
            productRecords:[]
        }
    },
    computed:{
        checkfetch(){
            return this.check();
        }
    },
    watch:{
        async product(val){
            if(val != ''){
                try{
                    const response = await this.$http.get(SERVER_API+'/product/byid/'+val);
                    this.natureType = response.data.data.nature;
                    this.pF = response.data.data.pF;
                }catch(error){
                    alert('Product Fetching Problem By watch Method')
                }
            }

        }
    },
    methods:{
        check(){
            if(this.productId){
                this.product = this.productId;
            }
        },
        Reset(){
            this.conditionRate = '';
            this.nonConditionRate = '';
            this.looseRatePbHr = '';
            this.looseRateSumerpur = '';
            this.readyRate = '';
            this.forwardRate = '';
            this.forReadyCday = '';
            this.forForwardCday = '';
            this.readyLiftingIn = '';
            this.forwardLiftingIn = '';
            this.natureType = '';
            this.product = '';
            this.pF = '';
        },
        close(){
            this.Reset();
            this.$emit('Close',false);
        },
        async fetchAll(){
            const response =  await this.$http.get(SERVER_API+'/product/records');
            this.productRecords = response.data.data;
        },
        async Save(){
            try{
                this.loading = true;
                const response = await this.$http.post(SERVER_API+'/dailyupdate/create',{
                    conditionRate: this.conditionRate,
                    nonConditionRate: this.nonConditionRate,
                    looseRatePbHr: this.looseRatePbHr,
                    looseRateSumerpur: this.looseRateSumerpur,
                    readyRate: this.readyRate,
                    forwardRate: this.forwardRate,
                    forReadyCday: this.forReadyCday,
                    forForwardCday: this.forForwardCday,
                    readyLiftingIn: this.readyLiftingIn,
                    forwardLiftingIn: this.forwardLiftingIn,
                    natureType: this.natureType,
                    product: this.product
                });
                this.loading = false;
                this.$emit('Response', response.data);
                this.close();
            }catch(error){
                this.$emit('Response', error);
            }
        },
    }

}
</script>

<style>

</style>